import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-sistema-mockup',
  templateUrl: './sistema-mockup.component.html',
  styleUrls: ['./sistema-mockup.component.scss']
})
export class SistemaMockupComponent {

  @Input() guiaAtivo = false;
  integracaoAberta = false;
  lancamentos: any[] = [];

  extratoBancario: any[] = [
    { soma: true,  data: 'Soma Total', saida: '-R$ 92.952,91', entrada: 'R$ 59.866,84', historico: '' },
    { data: '02/05/2026', saida: '-R$ 159,76',   entrada: '',             historico: 'BOLETO PAGO VERISURE BRA 9126' },
    { data: '02/05/2026', saida: '',             entrada: 'R$ 2.140,00',  historico: 'PIX TRANSF MAURICIO 02/05 9121' },
    { data: '03/05/2026', saida: '-R$ 1.355,67', entrada: '',             historico: 'BOLETO PAGO ADRL COMERCI 9925' },
    { data: '03/05/2026', saida: '',             entrada: 'R$ 3.484,00',  historico: 'MOV TIT COB DISP 03/05S 9123' },
    { data: '03/05/2026', saida: '-R$ 155,48',   entrada: '',             historico: 'TAR COBRANCA EXP 167' },
    { data: '03/05/2026', saida: '-R$ 21,20',    entrada: '',             historico: 'TAR PIX PGTO TRANSF 167' },
    { data: '04/05/2026', saida: '',             entrada: 'R$ 4.807,10',  historico: 'MOV TIT COB DISP 04/05S 9123' },
    { data: '05/05/2026', saida: '-R$ 1.071,48', entrada: '',             historico: 'BOLETO PAGO ALELO INSTIT 9124' },
    { data: '05/05/2026', saida: '-R$ 536,81',   entrada: '',             historico: 'BOLETO PAGO CARTAO DE CO 9026' },
    { data: '05/05/2026', saida: '-R$ 92,00',    entrada: '',             historico: 'BOLETO PAGO NR-9 MEDICIN 9129' },
    { data: '05/05/2026', saida: '',             entrada: 'R$ 4.635,26',  historico: 'MOV TIT COB DISP 05/05S 9953' },
    { data: '06/05/2026', saida: '-R$ 466,95',   entrada: '',             historico: 'BOLETO PAGO CARTAO DE CO 9130' },
    { data: '06/05/2026', saida: '-R$ 1.656,00', entrada: '',             historico: 'BOLETO PAGO RECORTE ACAB 9123' },
    { data: '09/05/2026', saida: '-R$ 471,30',   entrada: '',             historico: 'BOLETO PAGO D A PAPEIS C 9128' },
    { data: '09/05/2026', saida: '',             entrada: 'R$ 1.280,00',  historico: 'MOV TIT COB DISP 09/05S 9136' },
    { data: '10/05/2026', saida: '-R$ 3,96',     entrada: '',             historico: 'SISPAG TRIB MUNICIPAL 9925' },
    { data: '10/05/2026', saida: '-R$ 6,42',     entrada: '',             historico: 'SISPAG TRIB MUNICIPAL 9127' },
    { data: '10/05/2026', saida: '-R$ 1.500,00', entrada: '',             historico: 'PIX ENVIADO C.E.B. CORTE 9132' },
  ];

  processarIntegracao(): void {
    this.lancamentos = this.extratoBancario;
    this.integracaoAberta = false;
  }
}
